(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["athos-skeleton-reveal"] && !Shopify.designMode) return;
  try {
    const athosGrid = document.getElementById('athos-content');

  if (athosGrid) {
    const hasResults = () => athosGrid.querySelector('.ss__content .product-grid__item, .ss__no-results') !== null;

    const revealAthos = () => {
      for (const skeleton of document.querySelectorAll('[data-athos-skeleton]')) {
        const target = document.getElementById(skeleton.dataset.athosSkeleton);
        if (target) target.style.display = '';
        skeleton.hidden = true;
      }
    };

    if (hasResults()) {
      revealAthos();
    } else {
      const observer = new MutationObserver(() => {
        if (!hasResults()) return;

        revealAthos();
        observer.disconnect();
      });

      observer.observe(athosGrid, { childList: true });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
